module.exports = __webpack_public_path__ + "static/media/bem-estar.3b4fb702.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/categoria-interesse/bem-estar.jpg
// module id = 1927
// module chunks = 19